'use client';
import Image, { type ImageLoaderProps, type ImageProps } from 'next/image';
import { cn } from '~/lib/utils';

type FecomImageProps = Omit<ImageProps, 'loader' | 'src'> & {
  src: string | null;
  fecomMediaBaseUrl: string;
};

export const FecomImage = ({
  src,
  width,
  height,
  className,
  fecomMediaBaseUrl,
  alt,
  ...props
}: FecomImageProps) => {
  if (!src) {
    return (
      <Image
        src={'/placeholder.svg'}
        width={width}
        height={height}
        className={cn(className)}
        alt={alt}
        {...props}
      />
    );
  }

  return (
    <Image
      loader={fecomLoader}
      src={getFecomSrc(fecomMediaBaseUrl, encodeURI(src))}
      width={width}
      height={height}
      className={cn(className)}
      alt={alt}
      {...props}
    />
  );
};

function getFecomSrc(fecomMediaBaseUrl: string, src: string) {
  return `${fecomMediaBaseUrl}/${src}`;
}

const fecomLoader = ({ src, width, quality }: ImageLoaderProps) => {
  return `${src}?w=${width}&q=${quality ?? 75}`;
};
